export default Object.freeze({
  name: 'production',
  prod: true,
  'storage-prefix': 'b5a-pos',
  api: {
    baseURL: 'https://posrapor-apitest.ehesapp.com/api',
  },
});
